var map = {
	"./black/zhuapaijilu.png": "Tip4",
	"./blue/zhuapaijilu.png": "uLTu",
	"./white/zhuapaijilu.png": "YWEC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fw64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/zhuapaijilu\.png$
// module id = fw64
// module chunks = 24